import React, { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../state/authStore";

// Trigger bootstrap exactly once per app lifetime.
let didBootstrap = false;
function useBootstrapOnce() {
    const bootstrap = useAuthStore((s) => s.bootstrap);
    const fired = useRef(false);
    useEffect(() => {
        if (didBootstrap || fired.current) return;
        fired.current = true;
        didBootstrap = true;
        bootstrap();
    }, [bootstrap]);
}

const LoadingScreen = ({ testId }) => (
    <div className="min-h-screen flex items-center justify-center bg-canvas text-text-muted text-sm" data-testid={testId}>
        Loading…
    </div>
);

export const RequireAuth = ({ children }) => {
    useBootstrapOnce();
    const { user, isLoading } = useAuthStore();
    const location = useLocation();
    if (isLoading) return <LoadingScreen testId="auth-loading" />;
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    return children;
};

export const RequireSubscription = ({ children }) => {
    useBootstrapOnce();
    const { user, isLoading } = useAuthStore();
    const location = useLocation();
    if (isLoading) return <LoadingScreen testId="subscription-loading" />;
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    const ok =
        ["pro", "msp"].includes(user.subscription_plan) &&
        ["active", "trialing"].includes(user.subscription_status);
    if (!ok) return <Navigate to="/pricing?upgrade=required" replace />;
    return children;
};
